import ConsumedImg from '../images/consumedHero.jpg';
import ChainHero from '../images/theChain-hero.jpg';
import HomeImg from '../images/home-hero2.jpg';
import FoxImg from '../images/foxPortal.jpg';
import MydusaImg from '../images/Mydusa-hero.jpg';
import CareBareStareIMG from '../images/artist-hero25.jpg';
import TiltBananaIMG from '../images/TiltBanana.jpg';
import TripleThreatIMG from '../images/TripleThreat-Hero.jpg'

export const MainHeroImages = {
  images: 
    [
        {
            name: "Consumed Hero",
            imagePath: ConsumedImg
        },
        {
            name: "The Chain",
            imagePath: ChainHero
        },   
        {
            name: "Home Image",
            imagePath: HomeImg
        },   
        {
            name: "Fox Portal",
            imagePath: FoxImg
        },    
        {
            name: "Mydusa",
            imagePath: MydusaImg
        },    
        {
            name: "Care Bare Stare",
            imagePath: CareBareStareIMG
        },   
        {
            name: "Tilt Banana",
            imagePath: TiltBananaIMG
        },
        {
            name: "Tiger",
            imagePath: TripleThreatIMG
        }
    ]
}